import { Button } from '@netfront/ui-library';
import { ViewportButtonProps } from './ViewportButton.interfaces';
import { useRouter } from 'next/router';

export const ViewportButton = ({ action, hideOnRoutes = [] }: ViewportButtonProps) => {
  const { asPath } = useRouter();

  const shouldRender = !hideOnRoutes.some(route => asPath.includes(route));

  return shouldRender ? (
    <>
      <Button
        {...action}
        additionalClassNames="c-viewport-button rounded-b shadow-lg c-spotlight--help"
        variant="primary-inverse"
        size='small'
      />
    </>
  ) : null
};
